import HUBS from "@/data/hubs.yml";

function sameOrigin(a, b) {
  const urlA = new URL(a);
  const urlB = new URL(b);
  return urlA.origin === urlB.origin;
}

export default {
  data() {
    return {
      HUBS,
      currentTime: new Date().getTime(),
    };
  },
  methods: {
    onHubClick(event, href) {
      console.log(event, href);
      if (sameOrigin(href, window.location)) {
        event.preventDefault();
        this.$emit("close");
      }
    },
  },
};
